const cnfsdStudentBudgetCalc = (function () {
	// Define your variables
	let totalIncome;
	let totalExpenditure;
	let timescaleSet = false;
	let timescale = '';
	let firstMap;
	const totalIncomeSpan = document.querySelectorAll('.total-income');
	const totalExpenditureSpan = document.querySelectorAll('.total-expenditure');
	const totalRemainingSpan = document.querySelectorAll('.total-remaining');
	const totalRemainingOpposite = document.querySelectorAll('.total-remaining--opposite');
	const totalRemainingTerm = document.querySelectorAll('.total-remaining__per-term');
	const radios = document.querySelectorAll('#income input[type="radio"]');
	const sections = document.querySelectorAll('.student-budget-calculator form');
	const totalVals = [];

	function isNotEmptyOrNull(variable) {
		return variable !== null && variable !== undefined && variable !== '';
	}

	function setupMaps() {
		// Set up a map for the values in each section based on the section ID
		sections.forEach((sectionId, index) => {
			let map = `${sectionId.id}`;
			map = new Map();
			if (index > 0) {
				map.id = sectionId.id;
				totalVals.push({ id: map.id, map: map });
			} else {
				map.id = sectionId.id;
				firstMap = map;
			}
		});
	}

	// Event handlers
	function handleRadioInputs() {
		radios.forEach(radio => {
			radio.addEventListener('change', () => {
				validateRadios();
				timescale = radio.value;
				updateTimescales();
				calculateVals();
				updateHTMLVals(totalIncome, totalExpenditure);
				pushGAEvent(radio);
			});
		});
	}

	function handleButtons() {
		const buttons = document.querySelectorAll('.student-budget-calculator button');
		buttons.forEach(button => {
			button.addEventListener('click', event => {
				const section = button.closest('form');
				event.preventDefault();

				if (button.id === 'budgetCalc-continue') {
					if (!timescaleSet) {
						validateRadios();
						pushGAEvent(button, 'continue', false);
					} else {
						toggleSection();
						scrollCalcTop();
						pushGAEvent(button, 'continue', true);
					}
				}

				if (button.classList.contains('btn__add-category') || button.classList.contains('btn__new-category')) {
					addNewCategory(button, section);
					if (button.classList.contains('btn__add-category')) {
						pushGAEvent(button, 'addCategory', false);
					} else {
						pushGAEvent(button, 'newCategory', false);
					}
				}
			});
		});

		const downloadLink = document.querySelector('#budgetCalc-download-budget');
		downloadLink.addEventListener('click', event => {
			event.preventDefault();
			populateHiddenResults();
			generatePDF();
			pushGAEvent(downloadLink, 'download', false);
		});

		const backlinks = document.querySelectorAll('.edit-previous');
		backlinks.forEach(backlink => {
			backlink.addEventListener('click', event => {
				event.preventDefault();
				toggleSection();
				scrollCalcTop();
			});
		});
	}

	function handleTextInputs() {
		const inputs = document.querySelectorAll('.student-budget-calculator input[type="text"]');
		inputs.forEach(input => {
			const section = input.closest('form').id;
			input.addEventListener('keyup', () => {
				updateVals(input, section);
				calculateVals();
				updateHTMLVals(totalIncome, totalExpenditure);
			});
			input.addEventListener('keypress', event => {
				validateTextboxes(input, event);
			});

			input.addEventListener('focusout', () => {
				pushGAEvent(input);
			});
		});
	}

	function validateTextboxes(input, event) {
		if (input.classList.contains('calculation-val')) {
			if (
				(event.keyCode >= 48 && event.keyCode <= 57) ||
				(event.keyCode >= 37 && event.keyCode <= 39) ||
				event.keyCode === 63234 ||
				event.keyCode === 63235 ||
				event.keyCode === 8 ||
				event.keyCode === 45 ||
				event.keyCode === 189
			) {
				return true;
			} else if (event.keyCode === 46 && input.value.indexOf('.', 0) === -1) {
				return true;
			} else {
				event.preventDefault();
				return false;
			}
		} else {
			const regex = /^[\w\s]+$/;
			const keyed = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			const isValid = regex.test(keyed);
			if (!isValid) {
				event.preventDefault();
				return false;
			}
		}
	}

	function validateRadios() {
		timescaleSet = false;
		for (const radioButton of radios) {
			if (radioButton.checked) {
				timescaleSet = true;
				break;
			}
		}
		if (!timescaleSet) {
			radios[0].closest('.field-group').classList.add('field-group--error');
		} else {
			radios[0].closest('.field-group').classList.remove('field-group--error');
		}
		return timescaleSet;
	}

	function toggleSection() {
		const screen1 = document.querySelector('.student-budget-calculator__screen-1');
		const screen2 = document.querySelector('.student-budget-calculator__screen-2');
		const progressTitle = document.querySelector('.student-budget-calculator__progress--title');
		const progressCount = document.querySelector('.student-budget-calculator__progress--count');
		const progressIndicator = document.querySelector('.student-budget-calculator__progress--indicator');
		const progressTitle1 = document.querySelector('#student-budget-calculator__progress-title-1');
		const progressTitle2 = document.querySelector('#student-budget-calculator__progress-title-2');

		screen1.classList.toggle('display-none');
		screen2.classList.toggle('display-none');
		progressIndicator.classList.toggle('complete');

		if (screen1.classList.contains('display-none')) {
			if (isNotEmptyOrNull(progressTitle2)) {
				const progressTitle2Content = progressTitle2.innerHTML;
				progressTitle.innerHTML = progressTitle2Content;
			}
			progressCount.innerHTML = `2`;
		} else {
			if (isNotEmptyOrNull(progressTitle1)) {
				const progressTitle1Content = progressTitle1.innerHTML;
				progressTitle.innerHTML = progressTitle1Content;
			}
			progressCount.innerHTML = `1`;
		}
	}

	function scrollCalcTop() {
		const top = document.querySelector('.student-budget-calculator__progress');
		top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	}

	function updateTimescales() {
		const visibleTimescale = document.querySelector('.visible-timescale');
		visibleTimescale.classList.remove('display-none');
		const timeText = document.querySelectorAll('.transform-timescale');
		timeText.forEach(text => {
			text.innerHTML = timescale;
		});
		const amounts = document.querySelectorAll('.transform-amount');
		amounts.forEach(amount => {
			const val = parseInt(amount.getAttribute('data-amount'));
			const tscale = amount.getAttribute('data-timescale');
			if (tscale === timescale) {
				amount.innerHTML = `£${val}`;
				return;
			} else if (tscale === 'week' && timescale === 'month') {
				amount.innerHTML = `£${parseInt((val * 52) / 12)}`;
			} else {
				amount.innerHTML = `£${parseInt((val * 12) / 52)}`;
			}
		});

		const timeTextOpposites = document.querySelectorAll('.transform-timescale__Opposite');
		if (timescale === 'week') {
			timeTextOpposites.forEach(timeTextOpposite => {
				timeTextOpposite.innerHTML = 'month';
			});
		} else {
			timeTextOpposites.forEach(timeTextOpposite => {
				timeTextOpposite.innerHTML = 'week';
			});
		}
	}

	function addNewCategory(button, section) {
		const addCategory = section.querySelector('.add-category') || '';
		if (button.classList.contains('btn__add-category')) {
			addCategory.classList.remove('display-none');
			addCategory.querySelector('input[type="text"]').focus();
			button.classList.add('display-none');
		}
		if (button.classList.contains('btn__new-category')) {
			const newCategory = addCategory.querySelector('input[type="text"]').value;
			if (newCategory === null || newCategory === '') {
				return;
			} else {
				addCategory.classList.add('display-none');
				AddCategoryFragment(section, newCategory);
				addCategory.querySelector('input[type="text"]').value = '';
				section.querySelector('.btn__add-category').classList.remove('display-none');
			}
		}
	}

	function AddCategoryFragment(section, newCategory) {
		const questionGroup = section.querySelector('.question-group');
		const newElement = document.createElement('fieldset');
		newElement.classList.add('field-group', 'field-group--small', 'field-group--horizontal', 'user-created-input');
		const uniqueIDModifier = Math.floor(Math.random() * 10000);
		const categoryId = newCategory.replace(/\s/g, '');
		const inputPlaceHolderText = document.getElementById('student-budget-calculator__input-placeholder');
		let inputPlaceHolderTextValue;
		inputPlaceHolderTextValue = isNotEmptyOrNull(inputPlaceHolderText.innerHTML)
			? inputPlaceHolderText.innerHTML
			: 0;

		const template = `
            <div class='question-shell'>
                <label class='label--standard' style='word-break: break-word' for='budgetCalc-${categoryId}-${uniqueIDModifier}'>${newCategory}</label>
            </div>
            <div>
                <div class='input-shell input-shell--standard input-shell--prefixed input-shell--prefixed--pound'>
                    <input type='text' id='budgetCalc-${categoryId}-${uniqueIDModifier}' name='budgetCalc-${categoryId}-${uniqueIDModifier}' value='' maxlength='6" inputmode='decimal' placeholder='${inputPlaceHolderTextValue}' class='half-width calculation-val'>
                </div>
            </div>`;
		newElement.innerHTML = template;
		questionGroup.appendChild(newElement);
		handleTextInputs();
		document.getElementById(`budgetCalc-${categoryId}-${uniqueIDModifier}`).focus();
	}

	function updateVals(input, section) {
		let inputVal = '';
		const inputId = input.id;

		if (input.classList.contains('add-category-input')) {
			return;
		}

		if (input.value === null || input.value === '') {
			inputVal = 0;
		} else {
			inputVal = parseFloat(input.value);
		}

		if (section === firstMap.id) {
			// Update the firstMap directly
			firstMap.set(inputId, inputVal);
		} else {
			// Find and update the Map within totalVals
			const mapToUpdate = totalVals.find(item => item.id === section);
			if (mapToUpdate) {
				mapToUpdate.map.set(inputId, inputVal);
			}
		}
	}

	function calculateVals() {
		totalIncome = 0;
		totalExpenditure = 0;

		for (const value of firstMap.values()) {
			totalIncome += value;
		}
		for (const innermap of totalVals) {
			for (const value of innermap.map.values()) {
				totalExpenditure += value;
			}
		}
		return [totalIncome, totalExpenditure];
	}

	function updateHTMLVals(totalIncome, totalExpenditure) {
		totalIncomeSpan.forEach(totalincome => {
			totalincome.innerHTML = `${formatter.format(totalIncome)}`;
		});
		totalExpenditureSpan.forEach(totalexpenditure => {
			totalexpenditure.innerHTML = `${formatter.format(totalExpenditure)}`;
		});
		totalRemainingSpan.forEach(totalremaining => {
			totalremaining.innerHTML = `${formatter.format(totalIncome - totalExpenditure)}`;
			if (totalIncome - totalExpenditure < 0) {
				totalremaining.style.color = 'var(--themeErrorColour, #e61414)';
			} else {
				totalremaining.style.color = '';
			}
		});

		if (timescale === 'week') {
			totalRemainingOpposite.forEach(remainingOpposite => {
				remainingOpposite.innerHTML = ` ${formatter.format(((totalIncome - totalExpenditure) * 52) / 12)} `;
			});
			totalRemainingTerm.forEach(remainingTerm => {
				remainingTerm.innerHTML = ` ${formatter.format((((totalIncome - totalExpenditure) * 52) / 12) * 3)} `;
			});
		} else {
			totalRemainingOpposite.forEach(remainingOpposite => {
				remainingOpposite.innerHTML = ` ${formatter.format(((totalIncome - totalExpenditure) * 12) / 52)} `;
			});
			totalRemainingTerm.forEach(remainingTerm => {
				remainingTerm.innerHTML = ` ${formatter.format((totalIncome - totalExpenditure) * 3)} `;
			});
		}
	}

	function populateHiddenResults() {
		const breakdownSections = document.querySelectorAll('.question-group');
		const breakdownHolder = document.querySelector('#budgetCalc-results-card__print .breakdown');
		let breakdownHTML = '';

		breakdownSections.forEach(section => {
			breakdownHTML += `
                <section class='section-details' style='letter-spacing: normal;'>
                    <h3 style='break-inside: avoid; letter-spacing: normal; font-size: 22px; font-weight: 600; line-height: 28px; margin-top:24px; margin-bottom: 24px;'>
                        ${section.dataset.heading}
                    </h3>
                `;

			const questions = section.querySelectorAll('.field-group--horizontal');
			questions.forEach(question => {
				const label = question.querySelector('label').innerHTML;
				let value = question.querySelector('input').value;
				value = formatter.format(value);

				if (value !== '') {
					breakdownHTML += `
                        <p class='result-line' style='break-inside: avoid;  letter-spacing: normal; display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 18px; line-height: 26px;'>
                            <span>${label}</span>
                            <span class='total-remaining result-line__value' style='font-weight: 600; padding-left: 16px;'>${value}</span>
                        </p>
                    `;
				}
			});

			breakdownHTML += `</section>`;
		});

		breakdownHolder.innerHTML = breakdownHTML;
	}

	const formatter = new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
	});

	async function generatePDF() {
		const pdfOptions = {
			margin: 16,
			filename: 'Confused.com_Student_Budget.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: { scale: 2 },
			jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
		};

		const element = document.getElementById('printPageWrapper');
		html2pdf(element, pdfOptions);
	}

	async function pushGAEvent(input, inputType = '', validation = false) {
		if (typeof dataLayer === 'undefined') {
			// DataLayer is not defined
			// You can handle this situation here
			alert('no dataLayer');
		} else {
			// DataLayer exists and is defined
			// You can work with the dataLayer here

			let payload = {};

			if (input.getAttribute('type') === 'submit') {
				switch (inputType) {
					case 'continue':
						payload = {
							event: 'continue',
							continueValidation: validation,
							continueValidationErrors: collateErrorMessages(),
							elementId: input.getAttribute('id'),
							formId: input.form.getAttribute('id'),
						};
						break;
					case 'addCategory':
						payload = {
							event: inputType,
							elementId: input.getAttribute('id'),
							formId: input.form.getAttribute('id'),
						};
						break;

					case 'newCategory':
						payload = {
							event: inputType,
							elementId: input.getAttribute('id'),
							formId: input.form.getAttribute('id'),
						};
						break;

					case 'download':
						payload = {
							event: 'continue',
							elementId: input.getAttribute('id'),
						};
						break;
				}
			} else {
				if (
					(input.getAttribute('type') === 'text' && input.value === '') ||
					input.classList.contains('add-category-input')
				) {
					return;
				} else {
					payload = {
						event: `inputChange-${input.getAttribute('name')}`,
						[`${input.getAttribute('name')}_type`]: input.getAttribute('type'),
						[`${input.getAttribute('name')}_value`]: input.value,
						[`${input.getAttribute('name')}_inputId`]: input.getAttribute('id'),
						[`${input.getAttribute('name')}_formId`]: input.form.getAttribute('id'),
					};
				}
			}

			dataLayer.push(payload);
		}
	}

	function collateErrorMessages() {
		let continueValidationErrors = '';
		const errors = document.querySelectorAll('.field-group--error');

		errors.forEach(error => {
			const errorMessage = error.querySelector('.error-message');
			continueValidationErrors += `${errorMessage.innerHTML};`;
		});
		return continueValidationErrors;
	}

	function init() {
		setupMaps();
		handleRadioInputs();
		handleButtons();
		handleTextInputs();
	}

	return {
		init: init,
		handleRadioInputs: handleRadioInputs,
		handleButtons: handleButtons,
		handleTextInputs: handleTextInputs,
		calculateVals: calculateVals,
		updateHTMLVals: updateHTMLVals,
		totalIncome: totalIncome,
		totalExpenditure: totalExpenditure,
		totalIncomeSpan: totalIncomeSpan,
		totalExpenditureSpan: totalExpenditureSpan,
		totalRemainingSpan: totalRemainingSpan,
		totalRemainingOpposite: totalRemainingOpposite,
		totalRemainingTerm: totalRemainingTerm,
		radios: radios,
		totalVals: totalVals,
		firstMap: firstMap,
		formatter: formatter,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	cnfsdStudentBudgetCalc.init();
});
